const getFormattedTimestamp = () => {
  let now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
  let date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
  let hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
  let min = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
  return `${year}-${month}-${date}_${hour}-${min}`;
};

export default getFormattedTimestamp;
